import { formatInTimeZone } from "date-fns-tz";

export const formatMinutes = (minutes: number) => {
  return minutes.toLocaleString("en-US", {
    maximumFractionDigits: 2,
  });
};

export const formatUsageDateRange = (start: Date, end: Date) => {
  const startPattern = start.getUTCFullYear() === end.getUTCFullYear() ? "d MMM" : "d MMM yyyy";

  return `${formatInTimeZone(start, "UTC", startPattern)} – ${formatInTimeZone(end, "UTC", "d MMM yyyy")}`;
};
